import apiRequest from '../../index'

export default {
  path: '/v1/maintenance_pack/gmo/linkTypeGet',
  async post (param, appVersionHeader) {
    console.log(param.authid)
    await window.callNativeHTTPX()
    return apiRequest.post(`${this.path}`, { ...param }, {
      headers: {
        'HTTP-X-DAPP-USERID': window.DAPP_USERID,
        'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
        'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD,
        'APP-USERS-AUTH-ID': param.authid,
        'X-CLS-App-Version': appVersionHeader
      }
    })
  }
}
